import React, { Component } from 'react'
import Icon from './Icon'

class Check extends Component {
  render () {
    return (
      <Icon {...this.props}>
        <svg viewBox='0 0 24 24' className='icon__fill'>
          <polygon
            fillRule='evenodd'
            points='9.832 14.571 6.958 11.572 6 12.571 9.832 16.571 18.042 8 17.085 7'
          />
        </svg>
      </Icon>
    )
  }
}

export default Check
